var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center text-uppercase"},[_c('div',{staticClass:"mr-1"},[(_vm.language === 'en' || _vm.language === 'us')?_c('span',[_c('flag',{attrs:{"iso":"us"}})],1):_vm._e(),(_vm.language === 'es' || _vm.language === 'sp')?_c('span',[_c('flag',{attrs:{"iso":"es"}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }